import type { Doc } from "building-types/doc";
import { type Group } from "building-types/groups/group";
import type { DocEntityHandle, GroupHandle } from "building-types/handles/docEntityHandleTypes";
import { SystemGroups } from "../docSystemGroups";
import { docEntityIsGroupable } from "./docEntityGroupable";
import { docGetEntityGroupId } from "./docGetEntityGroupId";

export function docGetGroup(doc: Pick<Doc, "groups">, handle: GroupHandle): Group | undefined {
  return SystemGroups[handle.id] ?? doc.groups[handle.id];
}

export function docGetEntityGroup(doc: Doc, handle: DocEntityHandle): Group | undefined {
  if (handle.type === "GROUP") {
    return docGetGroup(doc, handle);
  }

  if (!docEntityIsGroupable(doc, handle)) {
    return undefined;
  }

  const groupId = docGetEntityGroupId(doc, handle);

  if (!groupId) {
    return undefined;
  }

  return docGetGroup(doc, { type: "GROUP", id: groupId });
}
